// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e5a44bae","977":"82f6550f"}[chunkId] + ".chunk.js";
};